import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SfxBtn from "src/components/button/SfxBtn.vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxBtnLink',
  props: {
  inline: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxBtn, _mergeProps({
    flat: "",
    dense: props.inline,
    padding: props.inline ? '0' : undefined
  }, _ctx.$attrs), _createSlots({ _: 2 }, [
    (_ctx.$slots.default)
      ? {
          name: "default",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.loading)
      ? {
          name: "loading",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "loading")
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["dense", "padding"]))
}
}

})